import { useEffect, useRef } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Singleton EventSource with pub/sub bus
let es = null;
const subscribers = new Set();
let currentToken = null;

function connect(token) {
  if (es) {
    try { es.close(); } catch (err) { console.debug("[useRealtime] close prev SSE failed", err); }
  }
  const url = `${BACKEND_URL}/api/events/stream${token ? `?token=${encodeURIComponent(token)}` : ""}`;
  es = new EventSource(url, { withCredentials: true });
  es.addEventListener("message", (e) => broadcast("message", safeParse(e.data)));
  es.addEventListener("notification", (e) => broadcast("notification", safeParse(e.data)));
  es.addEventListener("ready", (e) => broadcast("ready", safeParse(e.data)));
  es.addEventListener("error", (evt) => {
    // browser will retry automatically per SSE retry directive
    console.debug("[useRealtime] SSE error, browser will retry", evt?.type);
  });
}

function safeParse(s) {
  try { return JSON.parse(s); } catch (err) {
    console.warn("[useRealtime] bad SSE payload", s?.slice?.(0, 80));
    return {};
  }
}

function broadcast(type, data) {
  for (const fn of subscribers) {
    try { fn(type, data); } catch (err) { console.error("[useRealtime] subscriber threw", err); }
  }
}

export function ensureRealtime(token) {
  if (es && currentToken === token) return;
  currentToken = token;
  connect(token);
}

export function disconnectRealtime() {
  currentToken = null;
  if (es) {
    try { es.close(); } catch (err) { console.debug("[useRealtime] close SSE failed", err); }
    es = null;
  }
}

export function useRealtime(handler) {
  const ref = useRef(handler);
  useEffect(() => { ref.current = handler; }, [handler]);
  useEffect(() => {
    const fn = (type, data) => ref.current && ref.current(type, data);
    subscribers.add(fn);
    return () => { subscribers.delete(fn); };
  }, []);
}
